import {NgModule} from "@angular/core";
import {IonicPageModule} from "ionic-angular";
import {TranslateModule} from "@ngx-translate/core";
import {InstructionSlidesComponent} from './instruction-slides';



@NgModule({
  declarations: [
    InstructionSlidesComponent,
  ],
  imports: [
    TranslateModule.forChild(),
    IonicPageModule.forChild(InstructionSlidesComponent),
  ],
  exports: [
    InstructionSlidesComponent,
  ],
  entryComponents: [
  ]
})
export class InstructionSlidesComponentModule {
}



// WEBPACK FOOTER //
// ./src/components/instruction-slides/instruction-slides.module.ts